import useSWR from 'swr'
import { APIDecoratorWithBaseURI } from '../../Service/api'
import { AxiosError, AxiosResponse } from 'axios'
import { useMemo } from 'react'

export interface useBankListProps {
  NPS: AxiosResponse<FetchResponse> | undefined
  NPSloading: boolean
  NPSError: AxiosError
}

interface FetchResponse {
  success: boolean
  data: boolean
}

const swrOptions = {
  revalidateIfStale: false,
  revalidateOnFocus: false,
  revalidateOnReconnect: false,
}

export const useVerifyNps = (key: string): useBankListProps => {
  const url: string = `producer/analytics/getNPSVerify?key=${key}`

  const fetchData = async (): Promise<AxiosResponse> => {
    return await APIDecoratorWithBaseURI().get(url)
  }

  const { data, error, isLoading } = useSWR(url, fetchData, swrOptions)

  const memoizedValue = useMemo(
    () => ({
      NPS: data,
      NPSloading: isLoading,
      NPSError: error,
    }),
    [data, error, isLoading]
  )

  return memoizedValue
}
